<template>
    <div class="draw-font">
        <div class="input">
            <div><button @click="setText">新建</button></div>
            <div><input type="text" v-model="text"></div>
        </div>
        <slot></slot>
        <div class="color-list">
            <ul>
                <li 
                    v-for="(item,index) of colors" :key="index"
                    :style="`background-color:${item}`"
                    @click="selectColor(index)"
                    ></li>
            </ul>
        </div>

         <div class="back"><button @click="back">上一步</button></div>
    </div> 
</template>
<script>
export default {
    data(){
        return{
            text: '',
            colors:[ 
                    '#FF0000', '#FF8161', '#FFDA61', 
                    '#8FFF61', '#45C145', '#61FFF4', 
                    '#61B0FF', '#8561FF', '#C8A451',
                    '#B50A0A', '#386140', '#333333'
                    ]
        }
    },
    methods:{
        setText(){
            this.$emit('setText',this.text)
        },
        selectColor(index){
            this.$emit('selectColor', this.colors[index])
        },
         back(){
          this.$emit('quit2',false)
        }
    }
}
</script>
<style lang="scss" scoped>
    .draw-font{
        font-size: 0.28rem;
        background: white;
        .input{
            display:flex;
            border: 1px solid #DADADA;
            button{
                width: 1.41rem;
                height: 100%;
                border: 1px solid #DADADA;
                background: white;
            }
            input{
                width: 5.8rem;
                height: 0.88rem;
                border: none;
            }
        }
        .color-list{
            text-align: center;
            margin-top:0.8rem ;
            ul{
                li{
                    width: 0.48rem;
                    height: 0.48rem;
                    border-radius: 50%;
                    display: inline-block;
                    margin:0.15rem 0.3rem;
                }
            }
        }
        .back{
            text-align: center;
            margin-top: 0.6rem;
            button{
                font-size: 0.28rem;
                width: 4.68rem;
                height: 0.99rem;
                background: #FFC44E;
                border: none;
                border-radius: 30px;
                color: white;
            }
        }
    }
</style>